import { sendTestMatomoEvent } from "../../Analytics/MatomoManager/matomoTest";

// const API_BASE_URL = "https://sbapi.wavespb.com/api";
const API_BASE_URL = "https://api.wavespb.com/api";

let refreshTokenPromise = null;
let isRefreshing = false;
window.APP_VERSION = "2.0.7";
window.DEVICE_TYPE = 11;
window.GETCONTINUEDATA = [] // 9 for Samsung, 8 for LG, 11 for vidaa
window.OLD_TOKEN_VALIDITY = null; // in seconds
window.NEW_TOKEN_VALIDITY = null; // in seconds

let deviceType = window.DEVICE_TYPE;


const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");

  const gender =
    userDetails?.gender === 1
      ? "Male"
      : userDetails?.gender === 2
        ? "Female"
        : "Not Available";

  const age = userDetails?.dob
    ? calculateAge(userDetails.dob)
    : "100";

  const ages = age == "Not Available" ? 100 : age;


  const profile = JSON.parse(localStorage.getItem("myProfile"));

  const profileType =
    profile?.isKids === 0 || profile?.is_kid === 0
      ? "Adult"
      : profile?.isKids === 1 || profile?.is_kid === 1
        ? "Child"
        : "";


  function calculateAge(dobString) {
    if (!dobString) return null;
    const today = new Date();
    const dob = new Date(dobString);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // adjust if birthday hasn't happened yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }

// Utility to create base headers
const getDefaultHeaders = (withAuth = true) => {
  const headers = {
    platform: "0",
    age: age,
    lastupdated: "0000000000",
    country: localStorage.getItem("country"),
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
    profileid: localStorage.getItem("profileId"),
    userId: localStorage.getItem("userId"),
    Version: window.APP_VERSION,
    deviceType: "11",
    Deviceid: localStorage.getItem("uuid"),
    Devicetoken: localStorage.getItem("deviceIDInfo"),
    Devicemodel: localStorage.getItem("modelCode"),
  };

  if (withAuth) {
    const token = localStorage.getItem("JWTToken");
    const userDetails = localStorage.getItem("user_details");
    if (token && userDetails) {
      headers.Authorization = `Bearer ${token}`;
    } else{
      console.warn("No JWT token or user details found for authenticated request");
    }
  }

  return headers;
};

// Handle successful responses
const handleResponse = async (response) => {
  const data = await response.json();
  return {
    success: response.ok,
    status: response.status,
    data,
  };
};

// Handle fetch errors
const handleError = (error) => {
  console.error("Fetch Error:", error);
  return {
    success: false,
    status: null,
    message: error.message || "An error occurred during fetch",
  };
};

// Refresh JWT token
const refreshToken = async () => {
  const refresh = localStorage.getItem("refresh");
  if (!refresh) throw new Error("No refresh token available");

  const headers = getDefaultHeaders(false);
  headers.Authorization = `Bearer ${refresh}`;

  const response = await fetch(`${API_BASE_URL}/v1/refreshToken`, {
    method: "POST",
    headers,
  });

  if (!response.ok) throw new Error("Token refresh failed");

  const data = await response.json();
  const newAccess = data.data.access;
  const newRefresh = data.data.refresh;
  const tokenValidity = data.data.validity;

  console.log("Token refreshed successfully", data, tokenValidity);
  window.OLD_TOKEN_VALIDATY = tokenValidity; // in seconds
  window.NEW_TOKEN_VALIDATY = tokenValidity; // in seconds

  localStorage.setItem("JWTToken", newAccess);
  if (newRefresh) localStorage.setItem("refresh", newRefresh);
sendTestMatomoEvent({
              eventCategory:"SessionTimedOut",
              eventAction:"RefreshToken",
              eventName:`${newAccess}-${tokenValidity}`
            })
  return newAccess;
};


// Retry wrapper for requests
const withAuthRetry = async (fetchCall, withAuth = true) => {
  if (!withAuth) {
    try {
      const headers = getDefaultHeaders(false);
      const response = await fetchCall(headers);
      return await handleResponse(response);
    } catch (error) {
      return handleError(error);
    }
  }

  try {
    const headers = getDefaultHeaders(true);
    let response = await fetchCall(headers);

    if (response.status === 401 && localStorage.getItem("refresh")) {
      if (!isRefreshing) {
        isRefreshing = true;
        refreshTokenPromise = refreshToken().finally(() => {
          isRefreshing = false;
        });
      }

      try {
        const newToken = await refreshTokenPromise;
        const retryHeaders = {
          ...headers,
          Authorization: `Bearer ${newToken}`,
        };
        response = await fetchCall(retryHeaders);
      } catch (refreshError) {
        // ["JWTToken", "refresh", "user_details", "userId", "profileId"].forEach(
        //   (key) => localStorage.removeItem(key)
        // );

         ["JWTToken", "refresh"].forEach(
          (key) => localStorage.removeItem(key)
        );
        return {
          success: false,
          status: 401,
          authFailed: true,
          message: "Session expired. Please log in again.",
        };
      }
    }

    return await handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

// GET method with optional auth
const get = async (url, extraHeaders = {}, withAuth = true) => {
  return withAuthRetry(
    (requestHeaders) =>
      fetch(`${API_BASE_URL}${url}`, {
        method: "GET",
        headers: { ...requestHeaders, ...extraHeaders },
      }),
    withAuth
  );
};

// POST method with optional auth
const post = async (url, data, extraHeaders = {}, withAuth = true) => {
  return withAuthRetry(
    (requestHeaders) =>
      fetch(`${API_BASE_URL}${url}`, {
        method: "POST",
        headers: { ...requestHeaders, ...extraHeaders },
        body: JSON.stringify(data),
      }),
    withAuth
  );
};

const getBaseURL = () => API_BASE_URL;

// Export functions
export { get, post, getBaseURL };
